import taskService from 'resources/task/task.service';

import { uploadDocumentsToTask } from 'resources/document/workflows';

const getNewTaskMilestoneOrder = async ({ milestoneId }) => {
  const milestoneTasks = await taskService.getMilestoneTasks(milestoneId);

  return milestoneTasks?.length;
};

const createTaskWithDocument = async ({
  fileData, // nullable()

  ...taskData
}) => {
  const task = await taskService.createTask({
    ...taskData,
    milestoneOrder: taskData.milestoneOrder || await getNewTaskMilestoneOrder({ milestoneId: taskData.milestoneId }),
  });

  await uploadDocumentsToTask({
    fileData,
    taskId: task.id,
    taskCompanyId: task.company_id,
  });

  return task;
};

export {
  createTaskWithDocument,
};
